import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonService } from '../../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-image-doc',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './view-image-doc.component.html',
  styleUrl: './view-image-doc.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewImageDocComponent {
  @Input() ImageDocPath: string = '';
  public sanitizedPdfUrl: SafeResourceUrl | undefined;
  
  constructor(
    protected common: CommonService,
    protected sanitizer: DomSanitizer,
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.ImageDocPath);
  }

  close() {
    this.activeModal.close();
  }
}
